import { fetcher } from '@bmwe/data';
import {
  DistinctValuesDocument,
  type useDistinctValuesQuery,
} from '@bmwe/data/shared';
import { DistinctValuesResult } from '../../types';

type DistinctValuesVariables = Parameters<typeof useDistinctValuesQuery>[0];

/** A list whose text filters can offer the column's existing values (backend enum `DistinctValuesList`). */
export type DistinctValuesList = DistinctValuesVariables['list'];

export const fetchDistinctValues = async (
  list: DistinctValuesList,
  field: string,
  search: string,
): Promise<DistinctValuesResult> =>
  (
    await fetcher<
      { distinctValues: DistinctValuesResult },
      DistinctValuesVariables
    >(DistinctValuesDocument, { list, field, search })()
  ).distinctValues;
